// src/utils/ErrorBoundary.js

import React from 'react';

/**
 * ErrorBoundary com dois modos:
 * - Padrao (root): exibe erro full-screen — usado em index.js
 * - Compacto (compact): exibe card de erro inline — usado em views individuais
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Erro capturado:', error, errorInfo);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        const { compact = false } = this.props;

        if (compact) {
            return (
                <div className="flex flex-col items-center justify-center py-16 gap-4 text-center">
                    <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                        <span className="text-red-600 text-xl font-black">!</span>
                    </div>
                    <div>
                        <p className="font-bold text-gray-700 mb-1">Nao foi possivel carregar esta secao.</p>
                        <p className="text-xs text-gray-400 mb-4 max-w-xs mx-auto">
                            {this.state.error?.message || 'Erro desconhecido.'}
                        </p>
                    </div>
                    <button
                        onClick={() => this.setState({ hasError: false, error: null })}
                        className="px-5 py-2 bg-[#1B2B6B] hover:bg-[#142055] text-white text-sm font-bold rounded-xl transition-colors"
                    >
                        Tentar novamente
                    </button>
                </div>
            );
        }

        return (
            <div className="w-full flex justify-center items-center min-h-screen p-4 bg-[#F4F5F7]">
                <div className="bg-white rounded-2xl border border-red-200 shadow-sm text-center p-10 max-w-xl w-full">
                    <p className="text-2xl font-black text-red-600 mb-2">Erro inesperado</p>
                    <p className="text-gray-600 mb-4">O aplicativo encontrou um erro e nao pôde continuar.</p>
                    <p className="text-xs text-red-400 mb-6 font-mono text-left bg-red-50 p-3 rounded-xl break-words">
                        {this.state.error?.toString()}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl transition-colors"
                    >
                        Recarregar pagina
                    </button>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
